import { now } from "./clock";
export function formatCurrency(value: number, opts?: { compact?: boolean }): string {
  if (opts?.compact) {
    // Formatação manual e determinística (evita drift entre Node ICU e browser ICU
    // que causa hydration mismatch em valores como 4000 → "R$ 4 mil" vs "R$ 4,0 mil").
    const abs = Math.abs(value);
    const sign = value < 0 ? "-" : "";
    if (abs >= 1_000_000_000) {
      return `${sign}R$ ${(abs / 1_000_000_000).toFixed(1).replace(".", ",")} bi`;
    }
    if (abs >= 1_000_000) {
      return `${sign}R$ ${(abs / 1_000_000).toFixed(1).replace(".", ",")} mi`;
    }
    if (abs >= 1_000) {
      return `${sign}R$ ${(abs / 1_000).toFixed(1).replace(".", ",")} mil`;
    }
    return `${sign}R$ ${abs.toFixed(0)}`;
  }
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    // Valores das cartas sempre com centavos, como na planilha.
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat("pt-BR").format(value);
}

export function formatDate(date: string | Date): string {
  const d = typeof date === "string" ? new Date(date) : date;
  return new Intl.DateTimeFormat("pt-BR").format(d);
}

export function formatPercent(value: number): string {
  return (value * 100).toFixed(1) + "%";
}

export function daysSince(date: string | Date): number {
  const d = typeof date === "string" ? new Date(date) : date;
  const ms = now().getTime() - d.getTime();
  return Math.max(0, Math.floor(ms / (1000 * 60 * 60 * 24)));
}

export function hoursSince(date: string | Date): number {
  const d = typeof date === "string" ? new Date(date) : date;
  const ms = now().getTime() - d.getTime();
  return Math.max(0, Math.floor(ms / (1000 * 60 * 60)));
}

/** Quanto tempo passou desde `date`, em formato curto: "2h", "18h", "3 dias". */
export function formatDuration(date: string | Date): string {
  const h = hoursSince(date);
  if (h < 24) return `${h}h`;
  const d = Math.floor(h / 24);
  return d === 1 ? "1 dia" : `${d} dias`;
}

/** Telefone brasileiro com DDD enquanto digita: (41) 98888-7777 ou (41) 3333-4444. */
export function maskPhone(v: string): string {
  const d = v.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2) return d.length ? `(${d}` : "";
  const corte = d.length === 11 ? 7 : 6;
  if (d.length <= corte) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, corte)}-${d.slice(corte)}`;
}
